import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash";
import { Grid, Card, IconButton, FormControl, Select, InputLabel, MenuItem, OutlinedInput, Button, TextField, FormHelperText } from '@mui/material';

import { Edit, Delete, CardGiftcard } from '@mui/icons-material';
import FileUpload from '../../common/FileUpload';
import DatePicker from '../../common/DatePicker';
import Currency from '../../common/Currency';
import Dialog from '../../common/Dialog';

class DebitForm extends Component {
    state = { 
        credit_payment_mode: this.props.debit ? this.props.debit.credit_payment_mode : "",
        credit_bank: this.props.debit ? this.props.debit.credit_bank : "",
        credit_amount: this.props.debit ? parseFloat(this.props.debit.credit_amount) : "",
        credit_ref: this.props.debit ? this.props.debit.credit_ref : "",
        credit_creation_date: this.props.debit ? this.props.debit.credit_creation_date : new Date(),
        // credit_files: null,
        
        errors: {
            // credit_user_id: "",
            credit_creation_date: "",
            credit_ref: "",
            credit_payment_mode: "",
            credit_bank: "",
            credit_amount: "",
            // credit_files: "",
        },
        creditList: [],
        available: ""
        
    }

    handleChange = (e) => {
        const { name, value} = e.target;
        
        this.setState({
            [name]: value
        })
    }

    handleChangeDate = (date) => {
        this.setState({
            credit_creation_date: date
        })
    }

    // setFiles = (credit_files, error = "") => {
    //     console.log("[INFO] SET_PHOTO", credit_files);
    //     this.setState({
    //         credit_files,
    //         errors:{
    //             ...this.state.errors,
    //             credit_files:error
    //         }
    //     })
    // }
    validate = () => {
        let required = [
            // "credit_user_id",
            // "credit_amount",
            "credit_ref",
            "credit_payment_mode",
            "credit_bank",
            // "credit_files"
        ]

        if (!this.props.update){
            required.push("credit_amount")
        }
        let noError = true
        let errors = {}
        
        required.map(field => {
            if( isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, ! doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        this.setState({
            errors
        })
        
        return noError
    }
    handleSubmit = async () => {

        if( this.validate() ){
            let data = {}
            if (this.props.update) {
                data = Object.assign(data, this.props.debit)
            } else {
                data.credit_user_id = this.props.credit_user_id
                data.credit_src = this.props.credit_id
                data.credit_op = "DEBIT"
                data.credit_amount =  parseFloat(this.state.credit_amount)
            }
            data.credit_payment_mode =  this.state.credit_payment_mode
            data.credit_bank =  this.state.credit_bank
            data.credit_ref =  this.state.credit_ref
            data.credit_creation_date =  this.state.credit_creation_date
            // data.credit_files =  this.state.credit_files

            console.log('====================================');
            console.log("submit debit", {data});
            console.log('====================================');
            
            
            if (this.props.update) {
                await this.props.updateDebit(data)
            } else {
                await this.props.newDebit(data)
            }
            
            // // if NoErrors ...
            if(this.props.STATE.credits.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.credits.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.props.handleClose()
            }

        } else {
            this.props.notif("error", "Le formulaire contient des erreurs")
        }
    }
    
    render() {
        const { BANKS, USERS, CREDITS } = this.props;
        const { creditList } = this.state;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return (
            // <Dialog
            //     // disableBackdropClick
            //     open={true}
            //     // onClose={this.props.handleClose}
            //     onClose={(_, reason) => {reason !== "backdropClick" && this.props.handleClose()} }
            //     aria-labelledby="form-dialog-title"
            //     fullWidth
            //     maxWidth= "sm"
            //     scroll="body"
            // >
            //     <DialogTitle id="form-dialog-title">Retour sur Avance</DialogTitle>
            //     <DialogContent>
            <Dialog
                submitAction={this.handleSubmit}
                submitTitle="Débiter"
                close={this.props.handleClose}
                title="Retour sur Avance"
            >

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <DatePicker  
                            id="credit_creation_date" 
                            label="Date de Retour" 
                            name="credit_creation_date" 
                            value={this.state.credit_creation_date} 
                            handleChange={this.handleChangeDate} 
                            error={this.state.errors.credit_creation_date}
                            required
                            noPadding
                        />      
                    </Grid>   
               
                    <Grid item xs={12}>
                        <FormControl variant="outlined" style={{ width:'100%'}}>
                            <TextField
                                onChange={this.handleChange}
                                required
                                id="credit_amount"
                                error={!!this.state.errors.credit_amount}
                                helperText={this.state.errors.credit_amount}
                                value={this.state.credit_amount}
                                name="credit_amount"
                                label="Montant à Debiter"
                                variant="outlined"  
                                type="number"          
                                style={{width:"100%"}}
                                disabled={this.props.update}
                            />
                        </FormControl>
                        {this.props.credit_total_available &&
                            <FormHelperText >Disponible <Currency value={this.props.credit_total_available} /></FormHelperText>
                        }
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl variant="outlined" style={{ width:'100%'}}>
                            <TextField
                                onChange={this.handleChange}
                                required
                                id="credit_ref"
                                error={!!this.state.errors.credit_ref}
                                helperText={this.state.errors.credit_ref}
                                value={this.state.credit_ref}
                                name="credit_ref"
                                label="Référence"
                                variant="outlined"  
                                style={{width:"100%"}}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl required error={!!this.state.errors.credit_payment_mode} variant="outlined" style={{ width:'100%'}}>
                            <InputLabel htmlFor="credit_payment_mode">Mode de Paiement</InputLabel>
                            <Select
                                value={this.state.credit_payment_mode}
                                onChange={this.handleChange}
                                input={<OutlinedInput labelWidth={170} name="credit_payment_mode" id="credit_payment_mode" />}
                            >
                                <MenuItem value="ESPECES">ESPECES</MenuItem>
                                <MenuItem value="CHEQUE">CHEQUE</MenuItem>
                                <MenuItem value="PRELEVEMENT">PRELEVEMENT</MenuItem>
                                <MenuItem value="VIREMENT">VIREMENT</MenuItem>
                                <MenuItem value="GAB">GAB</MenuItem>
                                <MenuItem value="MOBILE MONEY">MOBILE MONEY</MenuItem>
                            </Select>
                            <FormHelperText >{this.state.errors.credit_payment_mode}</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} >
                        <FormControl variant="outlined"  error={!!this.state.errors.credit_bank} style={{width: "100%"}}>
                            <InputLabel htmlFor="credit_bank">Banque</InputLabel>
                            <Select
                                native
                                onChange={this.handleChange}
                                error={!!this.state.errors.credit_bank}
                                value={this.state.credit_bank}
                                input={
                                    <OutlinedInput 
                                        labelWidth={60} 
                                        name="credit_bank" 
                                        id="credit_bank" 
                                    />
                                }
                            >
                                <option value= "" />
                                { Object.values(BANKS).map( bank  => (
                                    <option value={bank.bank_id} key={bank.bank_id}>
                                        {bank.bank_name}
                                    </option>
                                )) }
                            </Select>
                            <FormHelperText>{this.state.errors.credit_bank}</FormHelperText>
                        </FormControl>
                    </Grid>        
                        {/* <Grid item xs={12}>
                            <FileUpload
                                label="Ajouter une Photo"
                                setFiles={this.setFiles} 
                                files={this.state.credit_files || []} 
                            />
                            <FormControl error={!!this.state.errors.credit_files} >
                                <br/>
                                <FormHelperText >{this.state.errors.credit_files}</FormHelperText>
                            </FormControl>
                        </Grid>                 */}
                </Grid>
                
            </Dialog>
        );
    }
}

export default DebitForm;